import { createRouter, createWebHashHistory } from "vue-router";
import { sso } from "roboflex-thalamus-sso-lib";

import InjetoraDashboard from "@/view/InjetoraDashboard.vue";
import PainelEdicao from "@/view/PainelEdicao.vue";
import PlanejamentoInjecao from "@/view/PlanejamentoInjecao.vue";
import GestaoProducaoKpis from "@/view/indicadores/GestaoProducaoKpis.vue";
import CadastroParametros from "@/view/CadastroParametros.vue";
import InspecaoIndicadores from "@/view/inspecao/InspecaoIndicadores.vue";
import RelatorioInspecao from "@/view/inspecao/RelatorioInspecao.vue";
import ParametrosInspecao from "@/view/inspecao/ParametrosInspecao.vue";
import InspecoesPrimeiraPeca from "@/view/inspecao/InspecoesPrimeiraPeca.vue";

import Inconformidades from "@/view/inconformidade/Inconformidades.vue";
import MetasProducao from "@/view/metas/MetasProducao.vue";
import { usePermissions } from "roboflex-thalamus-componentes-vue3-lib";
/* import RelatorioOps from "@/view/gestao-op/RelatorioOps.vue";
import FormularioCriacaoOp from "@/view/gestao-op/FormularioCriacaoOp.vue";
import PainelSetor2Vue from "@/view/Painel Montagem/PainelSetor2.vue"; */

export class RoutesName {
  static injetoraDashboard = "injetora-dashboard";
  static painelEdicao = "painel-edicao";
  static planejamentoInjecao = "planejamento-injecao";
  static gestaoProducaoKpis = "gestao-producao-kpis";
  static metasProducao = "metas-producao";
  static cadastroParametros = "cadastro-parametros";
  static inspecaoIndicadores = "inspecao-indicadores";
  static relatorioInspecao = "relatorio-inspecao";
  static parametrosInspecao = "parametros-inspecao";
  static inspecoesPrimeiraPeca = "inspecoes-primeira-peca";
  static inconformidades = "inconformidades";
  /*   static PainelMontagem = "painel-montagem"; */
  /*   static gestaoOp = "gestao-op"; */
  /*   static criacaoOp = "criacao-op"; */
}

const { loadPermissions, temPermissao } = usePermissions();

function sendUserToPortal() {
  const buildMode = process.env.NODE_ENV;
  if (buildMode == "production") {
    window.location.href = "https://portal.thalamus.ind.br/#/";
  } else {
    window.location.href = "https://portal-homologacao.thalamus.ind.br/#/";
  }
}

// valida se esta logado
async function guardMyroute(to, from, next) {
  const isValid = sso.validarSessao();

  if (isValid) {
    next();
  } else {
    sendUserToPortal();
  }
}

async function hasPermission(id) {
  await loadPermissions();
  // const permissoes = await loadPermissions();

  // const permissoes = await getPermissao();
  // Id da funcionalidade necessária pra acessar o módulo como um todo
  // const funcionalidadeNecessaria = id;
  return temPermissao(id);
}

const routes = [
  {
    path: "/painel-injecao",
    name: RoutesName.injetoraDashboard,
    component: InjetoraDashboard,
  },
  /*   {
    path: "/painel-montagem",
    name: RoutesName.PainelMontagem,
    component: PainelSetor2Vue,
  }, */
  {
    path: "/painel-edicao",
    name: RoutesName.painelEdicao,
    component: PainelEdicao,
    beforeEnter: () => hasPermission(62),
  },
  {
    path: "/planejamento-injecao",
    name: RoutesName.planejamentoInjecao,
    component: PlanejamentoInjecao,
  },
  {
    path: "/gestao-producao-kpis",
    name: RoutesName.gestaoProducaoKpis,
    component: GestaoProducaoKpis,
    beforeEnter: async (_to, _from, next) => {
      const ok = await hasPermission(245);
      ok ? next() : next(false);
    },
  },
  {
    path: "/metas-producao",
    name: RoutesName.metasProducao,
    component: MetasProducao,
  },
  {
    path: "/cadastro-parametros",
    name: RoutesName.cadastroParametros,
    component: CadastroParametros,
  },
  {
    path: "/inspecao-indicadores",
    name: RoutesName.inspecaoIndicadores,
    component: InspecaoIndicadores,
  },
  {
    path: "/relatorio-inspecao",
    name: RoutesName.relatorioInspecao,
    component: RelatorioInspecao,
  },
  {
    path: "/parametros-inspecao",
    name: RoutesName.parametrosInspecao,
    component: ParametrosInspecao,
  },
  {
    path: "/inspecoes-primeira-peca",
    name: RoutesName.inspecoesPrimeiraPeca,
    component: InspecoesPrimeiraPeca,
  },
  /*   {
    path: "/gestao-op",
    name: RoutesName.gestaoOp,
    component: RelatorioOps,
  }, */
  /*   {
    path: "/criacao-op",
    name: RoutesName.criacaoOp,
    component: FormularioCriacaoOp,
    beforeEnter: () => hasPermission(127),
  }, */
  {
    path: "/inconformidades",
    name: RoutesName.inconformidades,
    component: Inconformidades,
    beforeEnter: async (_to, _from, next) => {
      const ok = await hasPermission(200);
      ok ? next() : next(false);
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(guardMyroute);

export default router;
